<template>
	<div class="parent" style="height:calc(100vh - 50px); width:100%;">

		<comments
		:joborderid="comment_joborderid"
		:show="show_comments"
		v-on:cancel="cancel_comment"
		v-on:save="save_comment"
		></comments>

		<dialogue
			:title="dialogTitle"
			:paragraph="''"
			:button_names="dialogButtons"
			:show="dialogShow"
			:autocompleteId="autocompleteId"
			v-on:dialogue="dialogCall"
			v-on:cancel="dialogCancel"
		></dialogue>

		<div v-if="default_vesselpic!=''" style="display:inline;">
			<layout-3 :id=pageid1 :term=term :width=4 :height=2 style="float:left; width:70%;"></layout-3>
			<div style="float:right; width:25%; height:300px; margin:10px;">
				<vesselpic
					:dir="'vesselpics/vesselpic_'+parseInt(default_vesselpic)+'.jpg'"
					:vesselpic_id="default_vesselpic"
					style="height:300px;">
				</vesselpic>
			</div>
		</div>
		<div v-else>
			<layout-3 :id=pageid1 :term=term :width=4 :height=2></layout-3>
		</div>
		<hr style="margin-left:25px;margin-right:25px;"/>

		<div style="overflow-y:auto; margin-bottom:50px;">
			<layout-1 v-if="parent==true" :table_name="'Parent Job Order'"
			:id=pageid12 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :key=ponumberKey :term=term></layout-1>

			<layout-1 v-if="perms.includes('5')" :table_name="'Job Schedules'"
			:id=pageid2 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :button_perm="'8'" :button_name="'Select'" :term=term></layout-1>

			<layout-1 v-if="perms.includes('118')" :table_name="'Comments'"
			:id=pageid14 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :term=term :key=commentsKey></layout-1>

			<layout-1 v-if="perms.includes('6')" :table_name="'Documents'"
			:id=pageid3 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :button_perm="'38'" :button_name="'Select'" :term=term></layout-1>

			<layout-1 v-if="perms.includes('7')" :table_name="'TSheets'"
			:id=pageid4 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :term=term></layout-1>

			<layout-1 v-if="perms.includes('73')" :table_name="'Invoices'"
			:id=pageid5 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :button_perm="'73'" :button_name="'Select'" :term=term></layout-1>

			<layout-1 v-if="perms.includes('36')" :table_name="'Activities'"
			:id=pageid6 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :term=term></layout-1>

			<layout-1 v-if="perms.includes('38')" :table_name="'Report Times'"
			:id=pageid7 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :button_perm="'38'" :button_name="'Select'" :term=term></layout-1>

			<layout-1 v-if="perms.includes('60')" :table_name="'Subcontractor Hours'"
			:id=pageid8 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :button_perm="'60'" :button_name="'Edit'" :term=term></layout-1>

			<layout-1 v-if="perms.includes('70')" :key=ponumberKey :table_name="'PO Numbers'"
			:id=pageid9 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :button_perm="'71'" :button_name="'Select'" :term=term></layout-1>

			<layout-1 v-if="perms.includes('88')" :table_name="'Inventory Items'"
			:id=pageid11 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :select_reroute=true :button_perm="'88'" :button_name="'Select'" :term=term></layout-1>

			<layout-1 v-if="perms.includes('122')" :table_name="'WeChat Linking'"
			:id=pageid15 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :term=term></layout-1>

			<layout-1 v-if="perms.includes('140')" :table_name="'Joborder Change Log'"
			:id=pageid16 :searchbar=false :collapseable="true" :height_limit="false"
			:navbar=false :term=term></layout-1>

		</div>
		<div class="nav-bar">
			<div>
				<button v-if="perms.includes('15')" v-on:click="button('Edit')">Edit Job Order</button>
				<!--<button v-if="perms.includes('14')" v-on:click="button('Add')">Add Job Schedule</button>-->
				<button v-if="perms.includes('60')" v-on:click="button('Add_Subcontractor')">Add Subcontractor Hours</button>
				<button v-if="perms.includes('2')" v-on:click="button('Pictures')">View Pictures</button>
				<button v-if="perms.includes('67')" v-on:click="button('Files')">View Files</button>
				<button v-if="perms.includes('76')" v-on:click="createFinalReport()">Prepare Final Report</button>

				<button v-if="perms.includes('104') && parent==true" v-on:click="removeParent()">Remove Parent Job Order</button>
				<button v-else-if="perms.includes('104') && parent==false" v-on:click="addParent()">Set Parent Job Order</button>

				<button v-if="perms.includes('104')" v-on:click="addPoNumber()">Add PO Number</button>

				<button v-if="perms.includes('38')" v-on:click="createInvoice()">Create Invoice</button>

				<button v-if="perms.includes('118')" v-on:click="add_comment()">Add Comment</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid1:PAGES.EDIT_JOB_ORDERS_PAGE,
			pageid2:PAGES.SCHEDULES_PAGE,
			pageid3:PAGES.DOCUMENTS_PAGE,
			pageid4:PAGES.TIMESHEETS_PAGE,
			pageid5:PAGES.JOB_ORDER_INVOICES_PAGE,
			pageid6:PAGES.ACTIVITIES_PAGE,
			pageid7:PAGES.REPORT_TIMES_PAGE,
			pageid8:PAGES.SUBCONTRACTOR_HOURS_PAGE,
			pageid9:PAGES.JOBORDER_PO_NUMBER_PAGE,
			pageid10:PAGES.JOBORDER_VESSELPIC_PAGE,
			pageid11:PAGES.JOB_ORDER_INVENTORY_PAGE,
			pageid12:PAGES.JOB_ORDER_PARENT_PAGE,
			pageid13:PAGES.EDIT_INVOICE_PAGE_JOBORDER,
			pageid14:PAGES.JOBORDER_COMMENTS_PAGE,
			pageid15:PAGES.JOBORDER_WECHAT_PAGE,
			pageid16:PAGES.JOBORDER_CHANGE_PAGE,

			default_vesselpic:'',
			parent:false,

			dialogTitle:'',
			dialogButtons:[],
			dialogShow:false,
			autocompleteId:-1,
			ponumberKey:50,

			show_comments:false,
			comment_joborderid:0,
			commentsKey:0,
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.setPicture();
		this.setParent();
	},
	methods:{
		async setPicture(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid10,
						data:[this.term],
					}
				}
			).then((res) => {
				if(res.data.data.column_data[0][0]!=null){
					this.default_vesselpic = res.data.data.column_data[0][0];
				}
			});
		},
		async setParent(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid12,
						data:[this.term],
					}
				}
			).then((res) => {
				if(res.data.data.column_data[0][0]!=null){
					this.parent=true
				}
				this.ponumberKey++;
			});
		},
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid2,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},
		async createFinalReport (){
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid2,
						term:this.term,
					}
				}
			).then((res) => {
				if(res.data.to!=null && res.data.search!=null) {
					router.push('/'+res.data.to+'?q='+res.data.search);
				}
			});
		},
		async addPoNumber(){
			this.dialogShow = true;
			this.dialogTitle = 'Add PO Number'
			this.dialogButtons = ['Accept']
			this.autocompleteId = 48;
		},
		async addParent(){
			this.dialogShow = true;
			this.dialogTitle = 'Set Parent Job Order'
			this.dialogButtons = ['Accept']
			this.autocompleteId = 58;
		},
		async removeParent(){
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid12,
						data:[this.term, null, false],
					}
				}
			).then((res) => {
				this.parent=false;
				this.setParent();
			});
		},
		async createInvoice(){
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid13,
						data:[this.term],
					}
				}
			).then((res) => {
				if(res.data.to!=null && res.data.invoiceid!=null) {
					router.push('/'+res.data.to+'?q='+res.data.invoiceid);
				}
			});
		},
		async dialogCancel(){
			this.dialogShow=false;
		},
		async dialogCall(value, data){
			//alert(this.autocompleteId, data)
			var pageid = 0
			if(this.autocompleteId==48){
				pageid = this.pageid9
			}else{
				pageid = this.pageid12
			}

			api.postData(
				{
					type:"insert",
					data:{
						pageid:pageid,
						data:[this.term, data, true],
					}
				}
			).then((res) => {
				this.ponumberKey++;
				this.setParent();
			});

			this.dialogCancel();
		},
		async add_comment() {
			this.comment_joborderid = parseInt(this.term.substr(3,5));
			this.show_comments = true;
		},
		async cancel_comment() {
			this.comment_joborderid = 0;
			this.show_comments = false;
		},
		async save_comment(comment) {
			this.commentsKey++;
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/View_Job_Orders.vue